<script>

    import { get_region_by_id } from '$lib/app/static.js';
    //import { short_country_name } from "$lib/universal/lib.js";
    //import { reg_json } from "$lib/static/reg_json.js";
    //import { unp_json } from '$lib/static/unp_json.js';
    import { tcc_json } from '$lib/static/tcc_json.js';
    import Flag from "$lib/app/Flag.svelte";
    
    let {
        selectedRegIntId,
        selectedRegType
    } = $props();

    // We really need this if (eg. Gilbert Islands)
    let [countryId, countryName, regId, regionName] =
        $derived(selectedRegType == 'tcc' ?
            get_region_by_id(selectedRegIntId, 'tcc_json', tcc_json) :
            get_region_by_id(selectedRegIntId));
    
    //let [countryId, countryName, regId, regionName] = $derived(get_region_by_id(selectedRegIntId));

</script>
{#if selectedRegIntId}
<div id=hovered-region-name>
    <Flag reg={countryId} width=auto/>{#if regId != countryId}&hairsp;<Flag reg={regId} width=auto/>{/if} {countryName}
    {#if regionName && regionName != countryName} &mdash; {regionName}{/if}
    {#if import.meta.env.DEV}[{selectedRegIntId} {countryId} {regId} ({selectedRegType})]{/if}
</div>
{:else}
<div id=hovered-region-name>&nbsp;</div>
{/if}
<style>
#hovered-region-name {
    font-size: 0.9em;
    padding-bottom: 0.1em;
}
</style>
